module.exports = __webpack_public_path__ + "img/pateplay-stream.8615cdfa.svg";